import { updateTodo, deleteTodo } from './response'
import { rerender } from "./main"

const ulEl = document.querySelector('ul')
const delAllEl = document.querySelector('.options > button')
const loadingEl = document.querySelector('.loading')
const noTodoEl = document.querySelector('.no-todo')
const selectEl = document.getElementById('view-options')


let isEdit = false;


//Todo렌더링
export function renderTodo(todos) {
  console.log(todos)
  // 저장된 일정이 없을 때
  if(todos.length === 0) { 
    ulEl.innerHTML = ''
    delAllEl.style.display = 'none'
    loadingEl.style.display = 'none'
    noTodoEl.style.display = 'block'
    return
  }

  delAllEl.style.display = 'block'
  noTodoEl.style.display = 'none'

  if(selectEl.value === 'yet') {
    //미완료일정
    todos = todos.filter(todo => !todo.done)
  } else if (selectEl.value === 'done') {
    //완료일정
    todos = todos.filter(todo => todo.done)
  }

  const liEls = todos.map(todo => {
    const liEl = document.createElement('li')
    const chkInput = document.createElement('input')
    const txtInput = document.createElement('p')
    const divEl = document.createElement('div')
    const createDateEl = document.createElement('span')
    const editDateEl = document.createElement('span')
    const editBtn = document.createElement('button')
    const delBtn = document.createElement('button')
  
    liEl.dataset.id = todo.id;
    chkInput.setAttribute('type','checkbox')
    editBtn.classList.add('edit')
    delBtn.classList.add('del')

    todo.done ? ( // 인풋 체크여부 확인
      chkInput.checked = true,
      liEl.classList.add('checked')
      ) : chkInput.checked = false

    txtInput.textContent = todo.title
    createDateEl.textContent = `created ${todo.createdAt.slice(2,10)}`
    editDateEl.textContent = `updated ${todo.updatedAt.slice(2,10)}`
    editBtn.textContent = '수정'
    delBtn.textContent = '삭제'
    
    divEl.append(createDateEl, editDateEl)
    liEl.append(chkInput, txtInput, divEl, editBtn, delBtn)

    // 체크박스클릭
    chkInput.addEventListener('click',() => {
      todoCheck(liEl, chkInput, todo)
    })

    // 수정버튼클릭
    editBtn.addEventListener('click', (e) => {
      editTitle(e,todo)
    });

    // 삭제버튼클릭
    delBtn.addEventListener('click', async () => {
      await deleteTodo(todo)
      rerender()
    });

    return liEl
  });

  ulEl.innerHTML = ''
  ulEl.append(...liEls)
  loadingEl.style.display = 'none'
  delAllEl.style.display = 'block'
}


// 할 일 완료여부 수정
async function todoCheck (liEl, chkInput, todo) {
  if(chkInput.checked){
    liEl.classList.add('checked');
    todo.done = true
  } else {
    liEl.classList.remove('checked');
    todo.done = false
  }

  await updateTodo(todo)
  rerender()
}

//Todo 내용수정
function editTitle(e, todo) {
  isEdit = true
  
  const origin = todo.title
  const todoInput = e.target.parentElement.children[1]
  todoInput.setAttribute('contenteditable','true')
  todoInput.focus()

  //수정완료
  todoInput.addEventListener('focusout',async () => {
    if (isEdit && todoInput.textContent.trim().length > 0 && origin !== todoInput.textContent.trim()) {
      todo.title = todoInput.textContent.trim()
      await updateTodo(todo)
    }
    if (todoInput.textContent.trim().length < 1){
      todoInput.textContent = origin
    }
    todoInput.removeAttribute('contenteditable')
    isEdit = false;

    rerender()
  })
  //엔터키로 수정완료
  todoInput.addEventListener('keydown', event => {
    if (event.key === 'Enter' && !event.isComposing) {
      todoInput.blur()
    }
  })  
}